import { ARTICLE_PATHS } from './utils/constants/articleUrls'
import { CANVAS_URLS, EVENTS_URLS, EXTRANET_URLS, LEGACY_APP_URLS, MAP_URLS } from './utils/constants/externalUrls'

export const REQUIREMENT_DATA = {
  qualifying: {
    name: 'Qualifying',
    requirements: {
      'background_check': {
        name: 'Background Check',
        statuses: {
          'open': {
            label: 'Open',
            message: 'To apply as an Associate, please complete a background check through HireRight.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'pending': {
            label: 'Pending',
            message: 'Your background check was submitted. Results can take, on average, 2-4 business days.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Your background check was approved!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'denied': {
            label: 'Denied',
            message: "Unfortunately, your background check did not pass. Please reach out to our team to discuss your options.",
            primaryLinkText: 'Contact Member Services',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: 'To apply as an Associate, please complete a new background check.',
            primaryLinkText: 'Start Background Check',
            primaryLinkUrl: 'https://account.pga.org/background-check',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'playing_ability_test': {
        name: 'Playing Ability Test (PAT)',
        statuses: {
          'open': {
            label: 'Open',
            message: 'Your next step is to qualify for the PAT, you can do so by playing in an event or using an approved alternative.',
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: EVENTS_URLS.PAT_SEARCH,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: 'Learn More',
            infoLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST
          },
          'deferred': {
            label: 'Deferred',
            message: "You've chosen to defer your PAT for now. Register when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: EVENTS_URLS.PAT_SEARCH,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: "Your PAT is on Thursday, Sept 25th at 2:00pm EDT.",
            primaryLinkText: 'See Event Details',
            primaryLinkUrl: EVENTS_URLS.MY_EVENTS,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'qualified': {
            label: 'Qualified',
            message: "Congratulations, you have qualifying scores and can advance to Level 1. You will still need to pass the PAT in order to enroll as a PGA of America Professional by the end of Level 3.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: EVENTS_URLS.PAT_SEARCH,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST,
            infoLinkText: 'Learn More',
            infoLinkUrl: ARTICLE_PATHS.PLAYING_ABILITY_TEST
          },
          'failed': {
            label: 'Failed',
            message: "Unfortunately, your scores aren't passing. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: EVENTS_URLS.PAT_SEARCH,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Passed',
            message: 'Major milestone complete: you passed!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'expired': {
            label: 'Expired',
            message: "Unfortunately, your scores expired. Register to try again when you're ready.",
            primaryLinkText: 'Find a PAT',
            primaryLinkUrl: EVENTS_URLS.PAT_SEARCH,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'open': {
            label: 'Open',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Coursework',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'application': {
        name: 'Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: "Congratulations, you're now eligible to purchase Level 1.",
            primaryLinkText: 'Purchase Level 1',
            primaryLinkUrl: '#',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'approved': {
            label: 'Approved',
            message: 'Congratulations, you have completed the Qualifying Level!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the Qualifying Level!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level1: {
    name: 'Level 1',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Open the Education Portal to view the Facility Management 1 course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_COURSE_MANUALS,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_COURSE_MANUALS,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'virtual_seminar': {
        name: 'Virtual Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Find a week-long, virtual seminar to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: EVENTS_URLS.VIRTUAL_SEMINAR_L1_SEARCH,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_VIRTUAL_SEMINAR,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: 'Review Seminar Manuals',
            primaryLinkUrl: ARTICLE_PATHS.L1_VIRTUAL_SEMINAR,
            secondaryLinkText: 'View My Events',
            secondaryLinkUrl: EXTRANET_URLS.EVENT_HISTORY,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class runs from 8AM CT to approximately 4PM daily. Your virtual conference opens at 7:45AM.",
            primaryLinkText: 'Join Seminar',
            primaryLinkUrl: CANVAS_URLS.VIRTUAL_SEMINAR_CONFERENCE,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_VIRTUAL_SEMINAR,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for participating in the virtual seminar.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_PORTFOLIO,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 1 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio_afm': {
        name: 'Facility Management Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Build your Facility Management portfolio by applying the knowledge presented in the course manuals to a simulated environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_PORTFOLIO,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Facility Management portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio_tc': {
        name: 'Teaching & Coaching Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Qualifying Requirements to start Level 1.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Build your Teaching & Coaching portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.L1_PORTFOLIO,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Teaching & Coaching portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 2',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: "Congratulations, you're now eligible to purchase Level 2.",
            primaryLinkText: 'Purchase Level 2',
            primaryLinkUrl: LEGACY_APP_URLS.LEVEL_2_REGISTRATION,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.UNLOCKING_LEVEL_2,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 1!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level2: {
    name: 'Level 2',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Open the Education Portal to view the{{courseName}} course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L2_COURSE_MANUALS('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L2_COURSE_MANUALS('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: EVENTS_URLS.EDUCATION_SEARCH,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L2_SEMINAR('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar in Frisco, TX{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L2_SEMINAR('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class is at The Home of the PGA from 8AM CT to approximately 4PM daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: MAP_URLS.PGA_HQ,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for joining us in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 1 Requirements to start Level 2.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L2_PORTFOLIO('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 2 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'purchase': {
        name: 'Purchase Level 3',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to purchase Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: "Congratulations, you're now eligible to purchase Level 3.",
            primaryLinkText: 'Purchase Level 3',
            primaryLinkUrl: LEGACY_APP_URLS.LEVEL_3_REGISTRATION,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.UNLOCKING_LEVEL_3,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations, you have completed Level 2!",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  },
  level3: {
    name: 'Level 3',
    requirements: {
      'course_manuals': {
        name: 'Course Manuals',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Open the Education Portal to view the course manuals and get started.',
            primaryLinkText: 'Start Coursework',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L3_COURSE_MANUALS('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'in_progress': {
            label: 'In Progress',
            message: 'Open the Education Portal to pick up where you left off.',
            primaryLinkText: 'Resume Progress',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L3_COURSE_MANUALS('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job, you completed the required coursework.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'seminar': {
        name: 'Seminar',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Find a week-long seminar in Frisco, TX to attend.',
            primaryLinkText: 'Register Now',
            primaryLinkUrl: EVENTS_URLS.EDUCATION_SEARCH,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L3_SEMINAR('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'registered': {
            label: 'Registered',
            message: 'Prepare for your seminar in Frisco, TX{{seminarDate}} by reviewing the seminar manuals.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L3_SEMINAR('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'attending': {
            label: 'Attending',
            message: "It's seminar week! Class is at The Home of the PGA from 8AM CT to approximately 4PM daily.",
            primaryLinkText: 'Directions to PGA HQ',
            primaryLinkUrl: MAP_URLS.PGA_HQ,
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Thank you for joining us in Frisco, TX.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'portfolio': {
        name: 'Portfolio',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 2 Requirements to start Level 3.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'Build your portfolio by applying the skills and knowledge presented in the courses to your work environment.',
            primaryLinkText: 'Access Portfolio',
            primaryLinkUrl: CANVAS_URLS.HOME,
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: `${ARTICLE_PATHS.L3_PORTFOLIO('{{careerPathSlug}}')}`,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Great job! Your Level 3 work experience portfolio has been approved.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'final_exam': {
        name: 'Final Exam',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Complete all Level 3 Requirements to become eligible for the Final Exam.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: 'You are now eligible to take your Final Exam!',
            primaryLinkText: 'Take the Exam',
            primaryLinkUrl: '{{canvasUrl}}',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: 'Congratulations, you have completed the final step in your Path to Membership!',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      },
      'enrollment': {
        name: 'PGA of America Membership Application',
        statuses: {
          'locked': {
            label: 'Locked',
            message: 'Please complete all requirements in order to submit your application for Membership.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'open': {
            label: 'Open',
            message: "Congratulations, you're now eligible to apply for Membership.",
            primaryLinkText: 'Apply for Membership',
            primaryLinkUrl: 'https://account.pga.org/applications/membership',
            secondaryLinkText: 'View Guide',
            secondaryLinkUrl: ARTICLE_PATHS.MEMBER_APPLICATION,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'submitted': {
            label: 'Submitted',
            message: 'Your application has been submitted and is currently being reviewed.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'approved': {
            label: 'Approved',
            message: 'Congratulations, your application is approved! You will be included in the next available election, and will receive an official email notification once your election is complete.',
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: 'View Election Schedule',
            secondaryLinkUrl: ARTICLE_PATHS.ELECTION_SCHEDULE,
            infoLinkText: '',
            infoLinkUrl: ''
          },
          'complete': {
            label: 'Complete',
            message: "Congratulations! You're a PGA of America Member, officially joining a community of professionals with a legacy that spans over 100 years.",
            primaryLinkText: '',
            primaryLinkUrl: '',
            secondaryLinkText: '',
            secondaryLinkUrl: '',
            infoLinkText: '',
            infoLinkUrl: ''
          }
        }
      }
    }
  }
}

